
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 50 40","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.75 27.5H47.5v-8.438c0-.937-.469-1.953-1.172-2.656l-7.734-7.734C37.89 7.969 36.875 7.5 35.937 7.5H32.5V3.75C32.5 1.719 30.781 0 28.75 0h-20A3.75 3.75 0 005 3.75V7.5H.625A.616.616 0 000 8.125v1.25c0 .39.234.625.625.625h21.25c.313 0 .625.313.625.625v1.25c0 .39-.313.625-.625.625H3.125a.616.616 0 00-.625.625v1.25c0 .39.234.625.625.625h16.25c.313 0 .625.313.625.625v1.25c0 .39-.313.625-.625.625H.625a.616.616 0 00-.625.625v1.25c0 .39.234.625.625.625h16.25c.313 0 .625.313.625.625v1.25c0 .39-.313.625-.625.625H5v10c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5h10c0 4.14 3.36 7.5 7.5 7.5 4.14 0 7.5-3.36 7.5-7.5h3.75c.625 0 1.25-.547 1.25-1.25v-2.5c0-.625-.625-1.25-1.25-1.25zM12.5 36.25c-2.11 0-3.75-1.64-3.75-3.75a3.75 3.75 0 013.75-3.75c2.031 0 3.75 1.719 3.75 3.75a3.75 3.75 0 01-3.75 3.75zm25 0c-2.11 0-3.75-1.64-3.75-3.75a3.75 3.75 0 013.75-3.75c2.031 0 3.75 1.719 3.75 3.75a3.75 3.75 0 01-3.75 3.75zM43.75 20H32.5v-8.75h3.438l7.812 7.813V20z","fill":"currentColor"}})])
          )
        }
      }
    